import { store, websiteActions, ProductTypeHelper, DestinationType } from 'ltur-state-engine';
var initializeUserSorting = function (destinationType) {
    var key = destinationType === DestinationType.DESTINATION ? 'destination-list-sorting' : 'hotel-list-sorting';
    var sorting = window.sessionStorage.getItem(key);
    if (!sorting || new URL(location.href).searchParams.has('sorting'))
        return;
    var productType = store.getState().websiteState.app.url.context.productType;
    var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
    var pagination = store.getState().websiteState.app.url.query;
    store.dispatch(websiteActions.setPagination({
        page: pagination.page,
        size: pagination.size,
        sorting: [sorting]
    }, searchMaskGroupType));
};
export default initializeUserSorting;
